import { Injectable } from '@angular/core'
import { map } from 'rxjs/operators'
import { FeathersService } from '../feathers.service'
import { AssistanceTemplate } from '../../models/AssistanceTemplate'

@Injectable({
  providedIn: 'root',
})
export class AssistanceTemplateService {
  constructor(private feathers: FeathersService) {}

  getByClientId(clientId: number) {
    return this.feathers
      .find(AssistanceTemplate, { clientId, $limit: 500 })
      .pipe(map((records: AssistanceTemplate[]) => records.filter((r) => r.clientId === clientId)))
  }

  async create(assistanceTemplate: AssistanceTemplate) {
    assistanceTemplate.client = null
    return await this.feathers.create<AssistanceTemplate>(AssistanceTemplate.serviceName, assistanceTemplate)
  }

  async update(assistanceTemplate: AssistanceTemplate) {
    return await this.feathers.update<AssistanceTemplate>(AssistanceTemplate.serviceName, assistanceTemplate)
  }

  async delete(assistanceTemplate: AssistanceTemplate) {
    return await this.feathers.remove<AssistanceTemplate>(AssistanceTemplate.serviceName, assistanceTemplate)
  }
}
